<template>
  <div class="page-layout">
    <div class="page-menu p-0">
      <sc-placeholder name="jsstopmenu" :rendering="rendering" />
    </div>
    <div class="page-content pt-lg-12 pt-sm-12">
      <sc-placeholder name="jssmaincontent" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'PageLayout',
  data() {
    return {};
  },
  props: {
    rendering: {
      type: Object,
    },
  },
  computed: {},
  components: {
    ScPlaceholder: Placeholder,
  },
};
</script>

<style lang="scss" scoped>
.page-layout {
  background: map-deep-get($colors, 'white-off', 'base');
  min-height: 100vh;
  margin: 0 auto;
  .page-content {
    margin: 0 auto;
    padding-bottom: 1rem;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      max-width: 720px;
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      max-width: 1170px;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      margin: 0 15px;
    }
  }
  .page-menu {
    margin: 0 auto;
    max-height: 65px;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      max-width: 720px;
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      max-width: 1170px;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      margin: 0 15px;
    }
  }
}
</style>
